import { useFollows } from "../lib/follows-context";
import styles from "./FollowButton.module.css";

interface FollowButtonProps {
  installName: string;
  /** Name used in the confirmation toast. */
  name: string;
}

/**
 * Follow / Following toggle. Renders nothing while the flag is off. stopPropagation keeps a
 * click inside a clickable card or table row from also opening its detail page.
 */
export default function FollowButton({ installName, name }: FollowButtonProps) {
  const { enabled, isFollowing, toggle } = useFollows();
  if (!enabled) return null;

  const following = isFollowing(installName);
  return (
    <button
      type="button"
      aria-pressed={following}
      className={following ? styles.following : styles.follow}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        void toggle(installName, name, !following);
      }}
    >
      {following ? "Following" : "Follow"}
    </button>
  );
}
